<template>
  <v-layout>
    <v-dialog v-model="show" width="500">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Results for {{ editedItem.firstName }}
            {{ editedItem.lastName }}
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pt-6">
          <v-row>
            <v-col cols="12">
              <span class="text-h6 primary--text">Drug</span>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editedItem.drugStatus"
                :items="drugStatus"
                label="Status"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.drugDate"
                    label="Date"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="drugDate = parseDate(editedItem.drugDate)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="drugDate"
                  no-title
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.drugNotes"
                label="Notes"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <a
                v-if="editedItem.drugFile"
                :href="editedItem.filePathDrug"
                target="_blank"
              >
                {{ editedItem.drugFile }}
              </a>
              <v-file-input
                v-else
                v-model="editedItem.drugFile1"
                label="Drug Result"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row v-if="editedItem.type === 'd2'">
            <v-col cols="12">
              <span class="text-h6 primary--text">Alcohol</span>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="editedItem.alcoholStatus"
                :items="alcoholStatus"
                label="Status"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editedItem.alcoholDate"
                    label="Date"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    @blur="alcoholDate = parseDate(editedItem.alcoholDate)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="alcoholDate"
                  no-title
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.alcoholNotes"
                label="Notes"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <a
                v-if="editedItem.alcoholFile"
                :href="editedItem.filePathAlcohol"
                target="_blank"
              >
                {{ editedItem.alcoholFile }}
              </a>
              <v-file-input
                v-else
                v-model="editedItem.alcoholFile"
                label="Alcohol Result"
              ></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveResult()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import { mask } from 'vue-the-mask'

export default {
  props: ['visible', 'item'],

  directives: {
    mask,
  },

  data() {
    return {
      drugStatus: ['Pending', 'Pass', 'Fail', 'Invalid'],
      alcoholStatus: ['Pending', 'Pass', 'Fail'],
      drawMask: '##',
      editedItem: this.item,
      saving: false,
      showpassword: false,
      drugDate: null,
      alcoholDate: null,
      menu1: false,
      menu2: false,
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
    }
  },

  created() {
    const date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10)

    const dateFormatted = this.formatDate(date)
    console.log('dateFormatted', dateFormatted)

    this.drugDate = date
    this.editedItem.drugDate = dateFormatted
    this.editedItem.alcoholDate = dateFormatted

    this.loadItem()
  },

  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close', this.editedItem)
        }
      },
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.loadItem()
      }
    },

    drugDate(val) {
      if (val) {
        this.editedItem.drugDate = this.formatDate(this.drugDate)
      }
    },

    alcoholDate(val) {
      if (val) {
        this.editedItem.alcoholDate = this.formatDate(this.alcoholDate)
      }
    },

    editedItem: {
      handler: function() {
        this.saving = true
      },
      deep: true,
    },
  },

  methods: {
    loadItem() {
      this.editedItem = this.item
    },

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },

    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    async saveResult() {
      try {
        console.log('test')

        let formData = new FormData()
        formData.append('drugStatus', this.editedItem.drugStatus)
        formData.append('drugDate', this.editedItem.drugDate)
        formData.append('drugNotes', this.editedItem.drugNotes)
        formData.append('alcoholStatus', this.editedItem.alcoholStatus)
        formData.append('alcoholDate', this.editedItem.alcoholDate)
        formData.append('alcoholNotes', this.editedItem.alcoholNotes)

        if (this.editedItem.drugFile1 !== null) {
          formData.append('drugFile', this.editedItem.drugFile1.name)
          formData.append('files', this.editedItem.drugFile1)
          this.editedItem.drugFile = this.editedItem.drugFile1.name
        }

        if (this.editedItem.alcoholFile1 !== null) {
          formData.append('alcoholFile', this.editedItem.alcoholFile1.name)
          formData.append('files', this.editedItem.alcoholFile1)
          this.editedItem.alcoholFile = this.editedItem.alcoholFile1.name
        }

        const response = await Api().put(
          'results/' +
            this.editedItem.id +
            '/' +
            this.editedItem.consortiumDrawId,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )

        this.show = false

        // let objIndex = this.companies.findIndex(obj => obj.id == companyId)

        // this.companies[objIndex].active = active

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },
  },
}
</script>

<style>
.centered-input input {
  text-align: center;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>
